//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory3s', {
//        templateUrl: 'views/components/views/textileModelCategory3s/textileModelCategory3s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory3sService', function (stateService, textileModelCategory3sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCategories3: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory3s() {
//                vm.model.itemsListCategories3 = await textileModelCategory3sService.listTextileModelCategory3s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state) {
//                switch (state) {
//                    case 'textilemodelcategory3':
//                        stateService.go(state, { textilemodelcategory3_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadTextileModelCategory3s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
